import React, { Component } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";

class NoticeBoard extends Component {
  render() {
    const boardmembers = [
      {
        title:
          "MD & CEO Of United Hospital Mohammad Faizur Rahman Spoke To The Business Standard About Its Travails And Journey So Far, Including How The Hospital Is Coping With The Ongoing Pandemic.",
        dsc: "MD & CEO of United Hospital Mohammad Faizur Rahman spoke to The Business Standard about its travails and journey so far, including how the hospital is coping with the ongoing pandemic.",
        image:
          "https://uhlbd.com/administrator/uploads/images/Business%20Standard.jpg",
      },
      {
        title:
          "MD & CEO Of United Hospital Mohammad Faizur Rahman Spoke To Daily Bonik Barta About Its Travails And Journey So Far, Including How The Hospital Is Coping With The Ongoing Pandemic.",
        dsc: "MD & CEO of United Hospital Mohammad Faizur Rahman spoke to Daily Bonik Barta about its travails and journey so far, including how the hospital is coping with the ongoing pandemic.",
        image:
          "https://uhlbd.com/administrator/uploads/images/Bonik%20Barta.jpg",
      },
      {
        title:
          "United Hospital Signs MoU With DGHS (Directorate General Of Health Services) For Joint Collaboration To Operate Munshiganj Isolation Centre For Corona Virus (COVID19) Suspect/positive Patients",
        dsc: "At Gholtoli of Louhaganj Upazilla of Munshiganj, at one hour distance from Dhaka, a 25 bed Isolation Centre for Corona Virus (COVID19) suspect/positive patients, ...",
        image:
          "https://uhlbd.com/backend/web/post_uploads/medium/1586774469IMG_1489-1.jpg",
      },
      {
        title:
          "United Group Signed A Project Agreement With Bangladesh Railway Under Public Private Partnership",
        dsc: "United Enterprise and Company Limited, a sister concern of United Group signed a project agreement with Bangladesh Railway ...",
        image:
          "https://uhlbd.com/backend/web/post_uploads/medium/158677382818-1.jpg",
      },
      {
        title:
          "United Hospital Inaugurated 25-bed Isolation Unit At Munshiganj To Help Covid-19 Patients",
        dsc: "As part of initiative of United Group & extended part of the United Hospital, for COVID-19 patients ...",
        image:
          "https://uhlbd.com/backend/web/post_uploads/medium/1586773514IMG_8343.jpg",
      },
    ];
    return (
      <div>
        <Route component={Header} />
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody mt-5 mb-5">
          <div className="container p-3">
            <h2 className="text-secondary">NEWS & EVENTS</h2>
            <div className="row g-3 w-100 mx-auto">
              {boardmembers.map((menubars) => (
                <div className="col-md-12 mt-5 bg-light d-flex">
                  <div className="w-100">
                    <img
                      src={menubars.image}
                      alt=""
                      width={475}
                      height={267}
                      className="img-fluid"
                    />
                  </div>
                  <div className="content mt-3 w-100" key={menubars}>
                    <h6 className="text-dark">{menubars.title}</h6>
                    <p className="text-secondary mt-3">{menubars.dsc}</p>
                    {/* <p className='text-secondary text-center'>{menubars.company}</p> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Route component={Footer} />
      </div>
    );
  }
}
export default NoticeBoard;



// WEBPACK FOOTER //
// ./src/component/frontend/NoticeBoard.js